import React, { useContext, useState } from "react";
import {
    ConfirmDialog,
    DeleteButton,
    ListActionButtonProps,
    useNotifications,
    ValidationResult
} from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { useAdminIntegratorApi } from "../../../api/useAdminIntegratorApi";
import { IntegratorContext } from "../../../context/IntegratorContext";
import { IntegratorItem } from "../../IntegratorItem";
import { DeleteIntegratorValidationSummary } from "./DeleteIntegratorValidationSummary";

type DeleteIntegratorButtonProps = ListActionButtonProps<IntegratorItem>;

export const DeleteIntegratorButton: React.VFC<DeleteIntegratorButtonProps> = ({
    itemId
}: DeleteIntegratorButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [isValidating, setIsValidating] = useState<boolean>(true);

    const { deleteIntegrator, validateIntegratorDelete } = useAdminIntegratorApi();
    const [validationResult, setValidationResult] = useState<ValidationResult>();

    const { success } = useNotifications();
    const { deleteIntegratorItem } = useContext(IntegratorContext);

    const openDialog = () => {
        setIsDialogOpen(true);

        validateIntegratorDelete({ integratorId: itemId })
            .then((result) => {
                setValidationResult(result);
            })
            .finally(() => {
                setIsValidating(false);
            });
    };

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const handleDelete = async () => {
        await deleteIntegrator({ integratorId: itemId });
        deleteIntegratorItem(itemId);

        success("Integrator deleted");

        closeDialog();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <DeleteButton key={itemId} onClick={openDialog} />
            <ConfirmDialog
                title="Delete integrator"
                text="Are you sure you want to delete this integrator?"
                hidden={!isDialogOpen}
                confirm={{ onClick: handleDelete, disabled: isValidating }}
                cancel={{ onClick: closeDialog }}
                width={500}
            >
                <DeleteIntegratorValidationSummary validationResult={validationResult} isValidating={isValidating} />
            </ConfirmDialog>
        </AuthorizationWrapper>
    );
};
